// extracted by mini-css-extract-plugin
export default {"partonBlockForm":"partonBlockForm---TIoZe","partonBlockWrapperHolder":"partonBlockWrapperHolder---cDyjS","partonBlockWrapper":"partonBlockWrapper---ANvXl"};